import { DemoName } from './demo-name';

export const getDemoNamesFromGroup = (demosPerGroup: Map<any, DemoName[]>): DemoName[] => {
    if (!demosPerGroup) {
        return [];
    }
    return Array.from(demosPerGroup.values())
        .reduce((acc: DemoName[], value: DemoName[]) => acc.concat(value), []);
};
